"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRowConsumer = exports.TableRowProvider = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * Use React 16.3+ createContext API.
 */
var _React$createContext = _react.default.createContext(),
    TableRowProvider = _React$createContext.Provider,
    TableRowConsumer = _React$createContext.Consumer;

exports.TableRowConsumer = TableRowConsumer;
exports.TableRowProvider = TableRowProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90YWJsZS9zcmMvVGFibGVSb3dDb250ZXh0LmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsIlRhYmxlUm93UHJvdmlkZXIiLCJQcm92aWRlciIsIlRhYmxlUm93Q29uc3VtZXIiLCJDb25zdW1lciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUE7OzsyQkFNSUEsZUFBTUMsYUFBTixFO0lBRlFDLGdCLHdCQUFWQyxRO0lBQ1VDLGdCLHdCQUFWQyxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG4vKipcbiAqIFVzZSBSZWFjdCAxNi4zKyBjcmVhdGVDb250ZXh0IEFQSS5cbiAqL1xuY29uc3Qge1xuICBQcm92aWRlcjogVGFibGVSb3dQcm92aWRlcixcbiAgQ29uc3VtZXI6IFRhYmxlUm93Q29uc3VtZXJcbn0gPSBSZWFjdC5jcmVhdGVDb250ZXh0KClcblxuZXhwb3J0IHsgVGFibGVSb3dQcm92aWRlciwgVGFibGVSb3dDb25zdW1lciB9XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/table/src/TableRowContext.js
// module id = 91
// module chunks = 0